"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var DiscoveryConfig_1 = require("./DiscoveryConfig");
/**
 * Create a Discovery service application
 */
var DiscoveryService = /** @class */ (function () {
    function DiscoveryService(discoveryServiceUrl) {
        this.discoveryServerUrl = discoveryServiceUrl;
    }
    /**
     * Gets the configuration from the discovery service
     * @param {string} hostname
     * @returns {Promise.<DiscoveryConfig>}
     */
    DiscoveryService.prototype.getConfiguration = function (hostname) {
        /*
         * Create and return a promise that will contain the configuration object
         * on success, or an error on failure
         */
        var url = this.generateDiscoveryURL(hostname);
        return this.getRawConfiguration(url);
    };
    /**
     * Gets the configuration from the discovery service
     * @param {string} url
     * @returns {Promise.<DiscoveryConfig>}
     */
    DiscoveryService.prototype.getRawConfiguration = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            /*
             * If we are successful, parse the response into a DiscoveryConfig
             * and then return it
             */
            axios_1.default.request({ url: url, responseType: "json" })
                .then(function (response) {
                if (response.hasOwnProperty("data")) {
                    var config = _this.parseConfig(response.data);
                    if (config !== null) {
                        resolve(config);
                    }
                    else {
                        reject(0);
                    }
                }
                else {
                    reject(0);
                }
                /*
                 * Otherwise there's an error so lets fail and send back the
                 * status code.
                 */
            })
                .catch(function (response) {
                reject(response.status);
            });
        });
    };
    /**
     * Gets the configuration from the discovery service
     * @param {object} config
     * @returns {Promise.<DiscoveryConfig>}
     */
    DiscoveryService.prototype.parseLocalConfig = function (config) {
        var _this = this;
        return new Promise(function (resolve) {
            resolve(_this.parseConfig(config));
        });
    };
    /**
     *
     * @param data {any}
     */
    DiscoveryService.prototype.parseConfig = function (data) {
        var config = new DiscoveryConfig_1.DiscoveryConfig(data);
        /*
         * Set the site data of the config.
         */
        if (data.hasOwnProperty("site")) {
            var name_1 = "";
            var abbrName = "";
            var description = "";
            var organization = "";
            if (data.site.hasOwnProperty("name")) {
                name_1 = data.site.name;
            }
            if (data.site.hasOwnProperty("abbrName")) {
                abbrName = data.site.abbrName;
            }
            if (data.site.hasOwnProperty("description")) {
                description = data.site.description;
            }
            if (data.site.hasOwnProperty("organization")) {
                organization = data.site.organization;
            }
            config.setSite(name_1, abbrName, organization, description);
        }
        /*
         * Parse contact config
         */
        if (data.hasOwnProperty("contact")) {
            var name_2 = "";
            var email = "";
            var tel = null;
            if (data.site.hasOwnProperty("name")) {
                name_2 = data.site.name;
            }
            if (data.site.hasOwnProperty("email")) {
                email = data.site.email;
            }
            if (data.site.hasOwnProperty("tel")) {
                tel = data.site.description;
            }
            config.setContact(name_2, email, tel);
        }
        /*
         * Parse asset config
         */
        if (data.hasOwnProperty("assets")) {
            var logo = "";
            var logoAuth = "";
            if (data.assets.hasOwnProperty("logo")) {
                logo = data.assets.logo;
            }
            if (data.assets.hasOwnProperty("logoAuth")) {
                logoAuth = data.assets.logoAuth;
            }
            config.setAssetUrls(logo, logoAuth);
        }
        /*
         * Parse addresses config
         */
        if (data.hasOwnProperty("addresses")) {
            var api = "";
            var status_1 = "";
            var analytics = "";
            if (data.addresses.hasOwnProperty("api")) {
                api = data.addresses.api;
            }
            if (data.addresses.hasOwnProperty("status")) {
                status_1 = data.addresses.status;
            }
            if (data.addresses.hasOwnProperty("analytics")) {
                analytics = data.addresses.analytics;
            }
            config.setAddresses(api, status_1, analytics);
        }
        /*
         * Parse Plugins
         */
        if (data.hasOwnProperty("plugins")) {
            for (var i in data.plugins) {
                if (data.plugins.hasOwnProperty(i)) {
                    config.addPlugin(i, data.plugins[i]);
                }
            }
        }
        return config;
    };
    /**
     * Generate a URL to the exact file on the discoveryService.
     * @param {string} hostname
     */
    DiscoveryService.prototype.generateDiscoveryURL = function (hostname) {
        var encodedHostname = btoa(hostname);
        return this.discoveryServerUrl.replace("%s", encodedHostname);
    };
    return DiscoveryService;
}());
exports.DiscoveryService = DiscoveryService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGlzY292ZXJ5U2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9EaXNjb3ZlcnlTZXJ2aWNlL0Rpc2NvdmVyeVNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxnREFBNkM7QUFDN0MscURBQW9EO0FBRXBEOztHQUVHO0FBQ0g7SUFHRSwwQkFBWSxtQkFBMkI7UUFDckMsSUFBSSxDQUFDLGtCQUFrQixHQUFHLG1CQUFtQixDQUFDO0lBQ2hELENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksMkNBQWdCLEdBQXZCLFVBQXdCLFFBQWdCO1FBQ3RDOzs7V0FHRztRQUNILElBQU0sR0FBRyxHQUFHLElBQUksQ0FBQyxvQkFBb0IsQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUNoRCxPQUFPLElBQUksQ0FBQyxtQkFBbUIsQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUN2QyxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLDhDQUFtQixHQUExQixVQUEyQixHQUFHO1FBQTlCLGlCQTRCQztRQTNCQyxPQUFPLElBQUksT0FBTyxDQUFDLFVBQUMsT0FBTyxFQUFFLE1BQU07WUFDakM7OztlQUdHO1lBQ0gsZUFBSyxDQUFDLE9BQU8sQ0FBQyxFQUFFLEdBQUcsS0FBQSxFQUFFLFlBQVksRUFBRSxNQUFNLEVBQUUsQ0FBQztpQkFDekMsSUFBSSxDQUFDLFVBQUEsUUFBUTtnQkFDWixJQUFJLFFBQVEsQ0FBQyxjQUFjLENBQUMsTUFBTSxDQUFDLEVBQUU7b0JBQ25DLElBQU0sTUFBTSxHQUFHLEtBQUksQ0FBQyxXQUFXLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFDO29CQUMvQyxJQUFJLE1BQU0sS0FBSyxJQUFJLEVBQUU7d0JBQ25CLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQztxQkFDakI7eUJBQU07d0JBQ0wsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO3FCQUNYO2lCQUNGO3FCQUFNO29CQUNMLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQztpQkFDWDtnQkFFRDs7O21CQUdHO1lBQ0wsQ0FBQyxDQUFDO2lCQUNELEtBQUssQ0FBQyxVQUFDLFFBQXVCO2dCQUM3QixNQUFNLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1lBQzFCLENBQUMsQ0FBQyxDQUFDO1FBQ1AsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0lBQ0Q7Ozs7T0FJRztJQUNJLDJDQUFnQixHQUF2QixVQUF3QixNQUFjO1FBQXRDLGlCQUlDO1FBSEMsT0FBTyxJQUFJLE9BQU8sQ0FBQyxVQUFBLE9BQU87WUFDeEIsT0FBTyxDQUFDLEtBQUksQ0FBQyxXQUFXLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztRQUNwQyxDQUFDLENBQUMsQ0FBQztJQUNMLENBQUM7SUFFRDs7O09BR0c7SUFDSyxzQ0FBVyxHQUFuQixVQUFvQixJQUFTO1FBQzNCLElBQU0sTUFBTSxHQUFHLElBQUksaUNBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUV6Qzs7V0FFRztRQUNILElBQUksSUFBSSxDQUFDLGNBQWMsQ0FBQyxNQUFNLENBQUMsRUFBRTtZQUMvQixJQUFJLE1BQUksR0FBVyxFQUFFLENBQUM7WUFDdEIsSUFBSSxRQUFRLEdBQVcsRUFBRSxDQUFDO1lBQzFCLElBQUksV0FBVyxHQUFXLEVBQUUsQ0FBQztZQUM3QixJQUFJLFlBQVksR0FBVyxFQUFFLENBQUM7WUFDOUIsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLGNBQWMsQ0FBQyxNQUFNLENBQUMsRUFBRTtnQkFDcEMsTUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDO2FBQ3ZCO1lBQ0QsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLGNBQWMsQ0FBQyxVQUFVLENBQUMsRUFBRTtnQkFDeEMsUUFBUSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDO2FBQy9CO1lBQ0QsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLGNBQWMsQ0FBQyxhQUFhLENBQUMsRUFBRTtnQkFDM0MsV0FBVyxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDO2FBQ3JDO1lBQ0QsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLGNBQWMsQ0FBQyxjQUFjLENBQUMsRUFBRTtnQkFDNUMsWUFBWSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDO2FBQ3ZDO1lBQ0QsTUFBTSxDQUFDLE9BQU8sQ0FBQyxNQUFJLEVBQUUsUUFBUSxFQUFFLFlBQVksRUFBRSxXQUFXLENBQUMsQ0FBQztTQUMzRDtRQUVEOztXQUVHO1FBQ0gsSUFBSSxJQUFJLENBQUMsY0FBYyxDQUFDLFNBQVMsQ0FBQyxFQUFFO1lBQ2xDLElBQUksTUFBSSxHQUFXLEVBQUUsQ0FBQztZQUN0QixJQUFJLEtBQUssR0FBVyxFQUFFLENBQUM7WUFDdkIsSUFBSSxHQUFHLEdBQWtCLElBQUksQ0FBQztZQUM5QixJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLE1BQU0sQ0FBQyxFQUFFO2dCQUNwQyxNQUFJLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUM7YUFDdkI7WUFDRCxJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLE9BQU8sQ0FBQyxFQUFFO2dCQUNyQyxLQUFLLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7YUFDekI7WUFDRCxJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLEtBQUssQ0FBQyxFQUFFO2dCQUNuQyxHQUFHLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUM7YUFDN0I7WUFDRCxNQUFNLENBQUMsVUFBVSxDQUFDLE1BQUksRUFBRSxLQUFLLEVBQUUsR0FBRyxDQUFDLENBQUM7U0FDckM7UUFFRDs7V0FFRztRQUNILElBQUksSUFBSSxDQUFDLGNBQWMsQ0FBQyxRQUFRLENBQUMsRUFBRTtZQUNqQyxJQUFJLElBQUksR0FBVyxFQUFFLENBQUM7WUFDdEIsSUFBSSxRQUFRLEdBQVcsRUFBRSxDQUFDO1lBQzFCLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsTUFBTSxDQUFDLEVBQUU7Z0JBQ3RDLElBQUksR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQzthQUN6QjtZQUNELElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsVUFBVSxDQUFDLEVBQUU7Z0JBQzFDLFFBQVEsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQzthQUNqQztZQUNELE1BQU0sQ0FBQyxZQUFZLENBQUMsSUFBSSxFQUFFLFFBQVEsQ0FBQyxDQUFDO1NBQ3JDO1FBRUQ7O1dBRUc7UUFDSCxJQUFJLElBQUksQ0FBQyxjQUFjLENBQUMsV0FBVyxDQUFDLEVBQUU7WUFDcEMsSUFBSSxHQUFHLEdBQVcsRUFBRSxDQUFDO1lBQ3JCLElBQUksUUFBTSxHQUFXLEVBQUUsQ0FBQztZQUN4QixJQUFJLFNBQVMsR0FBVyxFQUFFLENBQUM7WUFFM0IsSUFBSSxJQUFJLENBQUMsU0FBUyxDQUFDLGNBQWMsQ0FBQyxLQUFLLENBQUMsRUFBRTtnQkFDeEMsR0FBRyxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUMsR0FBRyxDQUFDO2FBQzFCO1lBQ0QsSUFBSSxJQUFJLENBQUMsU0FBUyxDQUFDLGNBQWMsQ0FBQyxRQUFRLENBQUMsRUFBRTtnQkFDM0MsUUFBTSxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDO2FBQ2hDO1lBQ0QsSUFBSSxJQUFJLENBQUMsU0FBUyxDQUFDLGNBQWMsQ0FBQyxXQUFXLENBQUMsRUFBRTtnQkFDOUMsU0FBUyxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUMsU0FBUyxDQUFDO2FBQ3RDO1lBQ0QsTUFBTSxDQUFDLFlBQVksQ0FBQyxHQUFHLEVBQUUsUUFBTSxFQUFFLFNBQVMsQ0FBQyxDQUFDO1NBQzdDO1FBRUQ7O1dBRUc7UUFDSCxJQUFJLElBQUksQ0FBQyxjQUFjLENBQUMsU0FBUyxDQUFDLEVBQUU7WUFDbEMsS0FBSyxJQUFNLENBQUMsSUFBSSxJQUFJLENBQUMsT0FBTyxFQUFFO2dCQUM1QixJQUFJLElBQUksQ0FBQyxPQUFPLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQyxFQUFFO29CQUNsQyxNQUFNLENBQUMsU0FBUyxDQUFDLENBQUMsRUFBRSxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7aUJBQ3RDO2FBQ0Y7U0FDRjtRQUVELE9BQU8sTUFBTSxDQUFDO0lBQ2hCLENBQUM7SUFFRDs7O09BR0c7SUFDSywrQ0FBb0IsR0FBNUIsVUFBNkIsUUFBZ0I7UUFDM0MsSUFBTSxlQUFlLEdBQUcsSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQ3ZDLE9BQU8sSUFBSSxDQUFDLGtCQUFrQixDQUFDLE9BQU8sQ0FBQyxJQUFJLEVBQUUsZUFBZSxDQUFDLENBQUM7SUFDaEUsQ0FBQztJQUNILHVCQUFDO0FBQUQsQ0FBQyxBQTVLRCxJQTRLQztBQTVLWSw0Q0FBZ0IifQ==